import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, onMounted, createVNode, h, Fragment, render, watch, onUnmounted, VNodeProps } from 'vue'
import { AutocompleteApi, autocomplete } from '@algolia/autocomplete-js'
import '@algolia/autocomplete-theme-classic'
import { PromiseOrValue } from './TypeScriptUtil';


export default /*#__PURE__*/_defineComponent({
  __name: 'AutoCompleteInput',
  props: {
    placeholder: {},
    disabled: { type: Boolean },
    search: { type: Function },
    itemComponent: {},
    getComponentProps: { type: Function }
  },
  emits: [
  'resultSelected',
  'focus',
  'blur',
],
  setup(__props: any, { expose: __expose, emit }) {

const props = __props;





__expose({
  clear,
  focus,
  setValid,
  isDropdownElement,
})

const containerRef = ref<HTMLElement>()
let autocompleteApi: AutocompleteApi<{ value: string }> | undefined = undefined

function onFocus() { emit('focus') }
function onBlur() { emit('blur') }

onMounted(() => {
  autocompleteApi = autocomplete({
    container: containerRef.value!,
    placeholder: props.placeholder,
    getSources({ query }) {
      return [{
        sourceId: 'default', 
        getItems: () => searchOnce(query),
        templates: {
            item({ item }) { return createVNode(props.itemComponent, props.getComponentProps?.(item) ?? { item }) },
        },
        onSelect({ item }) {
          //console.log(`Autocomplete select result: ${item.value}`)
          emit('resultSelected', item)
        },
      }]
    },
    renderer: { createElement: h, Fragment, render },
    onStateChange({ state }) {
      //console.log(`Autocomplete input: ${state.query}`)
    },
    onReset({ state, event }) {
      //console.log(`Autocomplete reset`)
      event.preventDefault()
      event.stopPropagation()
    },
  });

  const input = containerRef.value?.querySelector('input.aa-Input') as HTMLInputElement | undefined
  input?.addEventListener('focus', onFocus)
  input?.addEventListener('blur', onBlur)
});

onUnmounted(() => {
  const input = containerRef.value?.querySelector('input.aa-Input') as HTMLInputElement | undefined
  input?.removeEventListener('focus', onFocus)
  input?.removeEventListener('blur', onBlur)
  autocompleteApi?.destroy()
})

let lastQuery = ''
let lastResults = [] as { value: string }[]

async function searchOnce(query: string) {
  if (query === lastQuery)
    return lastResults

  lastQuery = query
  lastResults = await props.search(query)
  return lastResults
}

function clear() {
  autocompleteApi?.setQuery('')
}

function focus() {
  const input = containerRef.value?.querySelector('input.aa-Input') as HTMLInputElement | undefined
  input?.focus()
}

function setValid(isValid: boolean) {
  const form = containerRef.value?.querySelector('form.aa-Form') as HTMLFormElement | undefined
  if (isValid) {
    form?.classList.remove('is-invalid')
  }
  else {
    form?.classList.add('is-invalid')
  }
}

function isDropdownElement(e: HTMLElement) {
  const panel = document.querySelector('.aa-Panel') as HTMLElement | undefined
  return !!panel?.contains(e)
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "containerRef",
    ref: containerRef,
    class: "auto-complete-input"
  }, null, 512))
}
}

})